import i18n from "i18next";
import { useEffect, useReducer } from "react";
import { getApplicationConfig } from "services/api.service";
import { initReactI18next } from "react-i18next";

const defaultTranslations = {
  sv: {
    "application.errorPage.title": "Något gick tyvärr fel",
    "application.receiptPage.footer.top.paragraph":
      "Om du har frågor går det bra att kontakta Tre Kronor på telefon:",
    "application.receiptPage.footer.header": "0771-23 33 33",
    "application.receiptPage.footer.bottom.paragraph": "Vardagar 08-17",
    "application.errorPage.body": "[Gå tillbaka till startsidan](/anmal-skada)",
    "application.receiptPage.title": "Tack för din anmälan!",
    "application.receiptPage.body":
      "Nu har vår samarbetspartner Tre Kronor Försäkring AB tagit emot din anmälan och de kommer ta hand om ditt ärende. De kommer kontakta dig inom två arbetsdagar.",
    "banner.tooltip.text":
      "Din anmälan och den information du lämnar hanteras av vår samarbetspartner Tre Kronor",
    "banner.tooltip.header":
      "Allt som du skriver nedan ses och sparas endast av Tre Kronor",
    "banner.tooltip.paragraph":
      "Swedbank och sparbankerna samarbetar med Tre Kronor Försäkring AB. Det betyder att din anmälan och information du lämnar kommer att hanteras av Tre Kronor. Det är också dem du ska kontakta om du har frågor om din skadeanmälan.",
    "error.filesize.label":
      "Dina filer överstiger totalt 15 mb. Pröva att spara om någon av dina filer i ett mindre format.",
    "list.add.label": "Lägg till fler",
    "list.item.change.label": "Ändra",
    "list.item.remove.label": "Ta bort",

    "step.review.label": "Kontrollera uppgifter",
    "step.review.description":
      "Kontrollera nedanstående uppgifter innan du skickar in din anmälan",

    "step.general.edit.label": "Ändra",
    "step.general.next.label": "Gå vidare",

    "flow.submit.label": "Skicka in anmälan",

    // Errors
    "error.required.label": "Du har glömt att svara på frågan",
    "error.dateformat.label":
      'Om du inte vet exakt datum, fyll då i "01" där du är osäker. Exempel: 2013-06-01 eller 2000-01-01.',
    "error.pattern.label": "Du har fyllt i felaktigt format",
  },
};

const initialState = {
  isLoading: true,
  isErroneous: false,
  heading: "",
  receivers: "webbskador@3kronor.se",
  emailSubject: "SUBJECT MISSING IN SDL",
  customerEmail: null,
  intro: "",
  trackingClaimProduct: "",
  trackingClaimEvent: "",
  trackingPageName: "",
  flow: {},
  translations: defaultTranslations,
};
const ACTIONS = {
  FLOW_FETCH_SUCCESS: "FLOW_FETCH_SUCCESS",
  FLOW_FETCH_ERROR: "FLOW_FETCH_ERROR",
};

function reducer(state, { type, payload }) {
  switch (type) {
    case ACTIONS.FLOW_FETCH_SUCCESS:
      return {
        ...state,
        ...payload,
        translations: {
          sv: { ...state.translations.sv, ...payload.translations.sv },
        },
        isLoading: false,
      };
    case ACTIONS.FLOW_FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
        isErroneous: true,
      };
    default:
      return state;
  }
}

export function useApplicationConfiguration({ url, fallbackValues }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await getApplicationConfig(url);
        // use reducer instead
        const payload = {
          ...data,
          receivers: data.receivers
            ? data.receivers.split(",").map((r) => r.trim())
            : initialState.receivers.split(",").map((r) => r.trim()),
        };
        dispatch({ type: ACTIONS.FLOW_FETCH_SUCCESS, payload });
      } catch (error) {
        dispatch({ type: ACTIONS.FLOW_FETCH_ERROR });
        console.error(error);
        // setIsErroneous(true);
        // setIsloading(false);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
  useEffect(() => {
    i18n.use(initReactI18next).init({
      resources: {
        sv: {
          /**
           * Merge default with translations provdided by application
           */
          translation: {
            ...state.translations.sv,
          },
        },
      },
      keySeparator: false,
      debug: false,
      lng: "sv",
      interpolation: {
        escapeValue: false,
      },
    });
  }, [state.translations.sv]);
  return state;
}
